import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userAuthSaga } from "../store/Actions/Pagos";

export const useAuth = (path, ref = null) => {
  //in every path change recall method
  //console.log("ref", ref);
  const dispatch = useDispatch();

  //Functions to disptach to saga!
  const getUserInfo = useCallback(() => dispatch(userAuthSaga()), [dispatch]);

  //Get values from Store Slices
  const isAuth = useSelector((stateG) => {
    return stateG.App.isAuth;
  });
  const userInfo = useSelector((stateG) => {
    return stateG.App.userInfo;
  });
  useEffect(() => {
    getUserInfo();
  }, [ref, path, getUserInfo]);

  return [isAuth, userInfo];
};
